import { computed } from "vue";
import { useMe } from "@/api/me";
import { allowed, hasCapability, type Requirement } from "@/lib/access";

/** The signed-in user plus permission helpers for gating UI. */
export function useSession() {
  const query = useMe();
  const me = computed(() => query.data.value ?? null);
  return {
    me,
    can: (capability: string) => hasCapability(me.value, capability),
    allows: (req: Requirement | undefined) => allowed(me.value, req),
    displayName: computed(() => me.value?.displayName || me.value?.username || ""),
  };
}
